import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { mutator } from 'satcheljs';
import { updateIsUndoNotificationShown } from 'owa-calendar-compose-form-actions';

export default mutator(updateIsUndoNotificationShown, actionMessage => {
    let viewState = getComposeStore();
    if (viewState?.uiState) {
        viewState.uiState.isUndoNotificationShown = actionMessage.isUndoNotificationShown;
    }
});
